import type { IconData } from '@stacksjs/iconify-core'

export const steps1: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M3 24a5 5 0 1 0 10 0a5 5 0 1 0-10 0m32 0a5 5 0 1 0 10 0a5 5 0 1 0-10 0m-16 0a5 5 0 1 0 10 0a5 5 0 1 0-10 0\"/><path stroke=\"#2859c5\" stroke-linejoin=\"round\" d=\"M3 24a5 5 0 1 0 10 0a5 5 0 1 0-10 0m32 0a5 5 0 1 0 10 0a5 5 0 1 0-10 0m-16 0a5 5 0 1 0 10 0a5 5 0 1 0-10 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M35 24h-6m-10 0h-6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default steps1
